import { render, staticRenderFns } from "./premiumForm.vue?vue&type=template&id=65926df6&scoped=true"
import script from "./premiumForm.vue?vue&type=script&lang=js"
export * from "./premiumForm.vue?vue&type=script&lang=js"
import style0 from "./premiumForm.vue?vue&type=style&index=0&id=65926df6&lang=scss&scoped=true"
import style1 from "./premiumForm.vue?vue&type=style&index=1&id=65926df6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65926df6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65926df6')) {
      api.createRecord('65926df6', component.options)
    } else {
      api.reload('65926df6', component.options)
    }
    module.hot.accept("./premiumForm.vue?vue&type=template&id=65926df6&scoped=true", function () {
      api.rerender('65926df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/infoFrom/premiumForm.vue"
export default component.exports